import { IImportPlan } from './i-asset-type-import';
import { IImportJobPlan, IImportJobPlanColumn } from './i-import-job';

/**
 * Turns the wizard's column mapping into the plan the server imports by.
 * [AVP-891]
 *
 * Every column carries its index AND the header text the browser read there.
 * The server compares the name against the header it parses and fails the job
 * outright on a mismatch, so a disagreement between the two parsers surfaces
 * as one named error instead of 200 000 rows written into the wrong columns.
 */
export const buildStartJobRequest = (
  plan: IImportPlan,
  header: string[],
  delimiter: string,
): IImportJobPlan => {
  if (plan.codeColumn < 0 || plan.descriptionColumn < 0) {
    throw new Error('the mapping needs both a code and a description column');
  }

  const nameAt = (index: number): string => header[index] ?? '';

  const codeColumn: IImportJobPlanColumn = {
    index: plan.codeColumn,
    name: nameAt(plan.codeColumn),
  };

  const descriptionColumn: IImportJobPlanColumn = {
    index: plan.descriptionColumn,
    name: nameAt(plan.descriptionColumn),
  };

  const propertyColumns: IImportJobPlanColumn[] = plan.propertyColumns
    .filter((column) => column.name.trim() !== '')
    .map((column) => ({
      index: column.columnIndex,
      name: nameAt(column.columnIndex),
      as: column.name.trim(),
    }));

  return {
    delimiter,
    codeColumn,
    descriptionColumn,
    propertyColumns,
  };
};

export default buildStartJobRequest;
